import { MutationTree } from 'vuex';
import { CascaderStore } from './types';

const mutations: MutationTree<CascaderStore> = {
  setSubmitState(state, flag: boolean) {
    state.isSubmit = flag;
  },

  setSelectArr(state, value: Array<string>) {
    state.selectArr = value;
  },

  setOtherValue(state, otherValue: string) {
    state.otherValue = otherValue;
  },

  setdurationStart(state, time: number) {
    state.durationStart = time;
  },

  setMaxLevel(state, level: number) {
    state.maxLevel = level;
  },

  clear(state) {
    state.isSubmit = false;
    state.selectArr = [];
    state.otherValue = '';
    state.durationStart = 0;
    state.maxLevel = 0;
  }
};

export default mutations;
